import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    children:[
      {
        path: '/home',
        name: 'HomeView',
        component: ()=>import('../views/HomeView'),
      }
    ]
  },
  {
    path:'/searchlist',
    name:'searchList',
    component: ()=>import('../views/SearchList/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView'),
    children:[
      {
        path:'/debugapi',
        name:'debugApi',
        component: ()=>import('../views/DebugApi/index.vue')
      },
      {
        path:'/show/:id',
        name:'detailView',
        component: ()=>import('../views/DetailView/index.vue')
      },
      {
        path:'/oldDoc/:id',
        name:'oldDocView',
        component: ()=>import('../views/OldDocView/index.vue')
      },
    ]
  }
];
const BASE_URL = process.env.BASE_URL;
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to) {
    if (!to.hash) {
      // 切换左侧菜单时详情内容滑动到顶部
      document.querySelector('.detail-view .detailcon')?.scrollTo(0, 0)
    }
  }
});

export default router;
